export function getYearRange(): Array<any>{
    let yearRange = new Array<any>();
    let year: number = 2020;
    let currentYear: number = new Date().getFullYear();
     for(let i = currentYear; i >= year; i--){
        yearRange.push(i);
     }

     return yearRange;
}